.focus\:offset-ring:focus {
  outline-offset: 1px;
  outline: solid 1px var(--blue-500, #44b1ff);
}

.bg-gray-900\/\[0\.06\] {
  --tw-bg-opacity: 0.06;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity));
}

.hover\:bg-gray-900\/\[0\.12\]:hover {
  --tw-bg-opacity: 0.12;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity));
}

.hover\:bg-gray-900\/\[0\.06\]:hover {
  --tw-bg-opacity: 0.06;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity));
}
